import { PatientAccountTokenResponse } from "@shared/dtos/responses/patientAccountResponses.dto"

import { axiosPatient } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const extendSession = async (): Promise<PatientAccountTokenResponse> => {
  const resp = await axiosPatient({
    url: "/patient/patientaccount/extendsession",
    method: "post",
  })
  return resp.data
}
